import axios from '../utils/AxiosInstance'

export default {
  // namespaced: true,
  state: {
    emails: {
      selectIds: [],
      filters: {},
      paginate: {},
      selectId: false
    }
  },
  mutations: {
    SET_EMAIL_SELECT_IDS (store, ids) {
      store.emails.selectIds = ids
    },
    REMOVE_EMAIL_SELECT_IDS (store, ids) {
      store.emails.selectIds = store.emails.selectIds.filter((v) => { return !ids.includes(v) })
    },
    SET_EMAIL_SELECT_ID (store, id) {
      store.emails.selectId = id
    },
    SET_EMAIL_FILTERS (store, filters) {
      store.emails.filters = filters
    },
    SET_EMAIL_PAGINATE (store, val) {
      store.emails.paginate = {
        limit: val.limit,
        page: val.page,
        pages: val.pages,
        total: val.total
      }
    }
  },
  getters: {
    getEmails: (store, getters) => {
      return store.emails.selectIds.map((id) => {
        return getters['entities/emails/find'](id)
      })
    },
    getEmailsFilters: (store, getters) => {
      return store.emails.filters
    },
    getEmailsPaginate: (store, getters) => {
      return store.emails.paginate
    },
    getEmail: (store, getters) => {
      return getters['entities/emails/find'](store.emails.selectId) || {}
    }
  },
  actions: {
    /*
    selectEmails
    */
    selectEmails ({commit, dispatch, getters, state}, filters) {
      return dispatch('getEmails', { ...filters, abortid: 'select-emails' })
      .then((response) => {
        commit('SET_EMAIL_FILTERS', filters)
        commit('SET_EMAIL_PAGINATE', response)
        commit('SET_EMAIL_SELECT_IDS', response.docs.map((item) => { return item._id }))
        return response
      })
    },
    /*
    refreshSelectEmails
    */
    refreshSelectEmails ({commit, dispatch, getters, state}) {
      return dispatch('selectEmails', getters.getEmailsFilters)
    },
    /*
    selectEmail
    */
    selectEmail ({commit, dispatch, getters, state}, id) {
      return dispatch('getEmailById', id)
      .then((response) => {
        commit('SET_EMAIL_SELECT_ID', response._id)
        return response
      })
    },
    /*
    getEmails
    */
    getEmails ({commit, dispatch, getters, state}, filters) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/emails`, { params: filters })
      .then((response) => {
        return dispatch('entities/emails/insert', {
          data: response.data.docs
        })
        .then((result) => {
          return {
            docs: result.emails || [],
            limit: response.data.limit,
            page: response.data.page,
            pages: response.data.pages,
            total: response.data.total
          }
        })
      })
    },
    /*
    getEmailById
    */
    getEmailById ({commit, dispatch, getters, state}, id) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/emails/${id}`)
      .then((response) => {
        return dispatch('entities/emails/insert', {
          data: response.data
        })
      })
      .then((result) => {
        return result.emails[0]
      })
    },
    /*
    createEmail
    */
    createEmail ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .post(`/accounts/${getters.getAccount._id}/emails/send`, data)
      .then((response) => {
        return dispatch('entities/emails/insert', {
          data: response.data
        })
      })
      .then((response) => {
        dispatch('changeEmail', response.emails[0])
        return response.emails[0]
      })
    },
    /*
    validateCreateEmail
    */
    validateCreateEmail ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .post(`/accounts/${getters.getAccount._id}/emails/validate-send`, data)
    },
    /*
    updateEmailRead
    */
    updateEmailRead ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .put(`/accounts/${getters.getAccount._id}/emails/${data._id}/read`, data)
      .then((response) => {
        return dispatch('entities/emails/insert', {
          data: response.data
        })
      })
      .then((response) => {
        dispatch('changeEmail', response.emails[0])
        return response.emails[0]
      })
    },
    /*
    deleteEmail
    */
    deleteEmail ({commit, dispatch, getters, state}, id) {
      return axios
      .delete(`/accounts/${getters.getAccount._id}/emails/${id}`)
      .then((response) => {
        commit('REMOVE_EMAIL_SELECT_IDS', [id])
        dispatch('entities/emails/delete', id)
        dispatch('changeEmail', {})
        return {}
      })
    },
    /*
    changeEmail
    */
    changeEmail ({commit, dispatch, getters, state}, data) {
      dispatch('setProfileCounts')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/Email.js